import React from 'react';
import { Globe, Hash, Flag, Book, Award } from 'lucide-react';
import EtablissementInfoCard from './EtablissementInfoCard';

const EtablissementDetails = ({ etablissement }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
      <EtablissementInfoCard
        icon={Globe}
        title="Site Web"
      >
        {etablissement.site_web ? (
          <a 
            href={etablissement.site_web}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#202654] hover:text-[#2a2f6a] hover:underline text-lg inline-flex items-center font-medium"
          >
            {etablissement.site_web}
            <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        ) : (
          <p className="text-gray-500 text-lg">Non spécifié</p>
        )}
      </EtablissementInfoCard>

      <EtablissementInfoCard
        icon={Hash}
        title="Boîte Postale"
      >
        <p className="text-lg font-medium">{etablissement.bp}</p>
      </EtablissementInfoCard>

      <EtablissementInfoCard
        icon={Flag}
        title="Pays"
      >
        <p className="text-lg font-medium">{etablissement.pays}</p>
      </EtablissementInfoCard>

      <EtablissementInfoCard
        icon={Book}
        title="Ministère de Tutelle"
      >
        <p className="text-lg font-medium">{etablissement.ministere}</p>
      </EtablissementInfoCard>

      <EtablissementInfoCard
        icon={Award}
        title="Paramètres Académiques"
      >
        <div className="space-y-3">
          <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
            <span className="text-sm font-medium text-gray-600">Contrôle:</span>
            <span className="font-semibold text-[#202654]">
              {etablissement.pourcentage_note_controle ? `${etablissement.pourcentage_note_controle}%` : 'Non défini'}
            </span>
          </div>
          <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
            <span className="text-sm font-medium text-gray-600">Examen:</span>
            <span className="font-semibold text-[#202654]">
              {etablissement.pourcentage_note_examen ? `${etablissement.pourcentage_note_examen}%` : 'Non défini'}
            </span>
          </div>
        </div>
      </EtablissementInfoCard>
    </div>
  );
};

export default EtablissementDetails; 